export default "__VITE_ASSET__C4O_3uMC__"